import moment from 'moment';
import 'moment-timezone';
import { useState } from 'react';
import ChooseLanguage from './chooseLanguage';
import FormatTime from './FormatTime';

const TimeFunction = (dString, lang = 'fa') => {
  moment.locale(`${lang}`);
  // moment().tz('Asia/Tehran').format();
  // return moment.tz(dString, 'Asia/Tehran').local().format('HH:MM - YYYY-MM-DD');
  // return moment(dString).format('HH:MM - YYYY-MM-DD');
  return moment(dString).format('HH:mm - YYYY-MM-DD');

  // let timeValues = ChooseLanguage(lang)?.content?.time;

  // let DateDiff = {
  //   inSeconds: function (d1, d2) {
  //     let t2 = d2.getTime();
  //     let t1 = d1.getTime();

  //     return parseInt((t2 - t1) / 1000);
  //   },

  //   inMinutes: function (d1, d2) {
  //     let t2 = d2.getTime();
  //     let t1 = d1.getTime();

  //     return parseInt((t2 - t1) / 60000);
  //   },

  //   inHours: function (d1, d2) {
  //     let t2 = d2.getTime();
  //     let t1 = d1.getTime();

  //     return parseInt((t2 - t1) / 3600000);
  //   },

  //   inDays: function (d1, d2) {
  //     let t2 = d2.getTime();
  //     let t1 = d1.getTime();

  //     return parseInt((t2 - t1) / (24 * 3600 * 1000));
  //   },

  //   inWeeks: function (d1, d2) {
  //     let t2 = d2.getTime();
  //     let t1 = d1.getTime();

  //     return parseInt((t2 - t1) / (24 * 3600 * 1000 * 7));
  //   },

  //   inMonths: function (d1, d2) {
  //     let d1Y = d1.getFullYear();
  //     let d2Y = d2.getFullYear();
  //     let d1M = d1.getMonth();
  //     let d2M = d2.getMonth();

  //     return d2M + 12 * d2Y - (d1M + 12 * d1Y);
  //   },

  //   inYears: function (d1, d2) {
  //     return d2.getFullYear() - d1.getFullYear();
  //   },
  // };

  // // let dString = "May, 20, 1984"; //will also get (Y-m-d H:i:s)

  // let d1 = new Date(dString);
  // let d2 = new Date();

  // // console.log("time===", d1, d2)
  // let timeLaps = DateDiff.inSeconds(d1, d2);
  // let dateOutput = '';

  // // if (timeLaps < 0 && timeLaps < 60) {
  // //     dateOutput = 0 + " ثانیه پیش";
  // // }
  // console.log('timeLaps==', timeLaps);
  // if (timeLaps < 60) {
  //   // dateOutput = timeLaps + `${timeValues?.seconds}`;
  //   dateOutput = `${timeValues?.some} ${timeValues?.seconds}`;
  // } else {
  //   timeLaps = DateDiff.inMinutes(d1, d2);
  //   if (timeLaps < 60) {
  //     dateOutput = timeLaps + `${timeValues?.minutes}`;
  //   } else {
  //     timeLaps = DateDiff.inHours(d1, d2);
  //     if (timeLaps < 24) {
  //       dateOutput = timeLaps + `${timeValues?.hours}`;
  //     } else {
  //       timeLaps = DateDiff.inDays(d1, d2);
  //       if (timeLaps < 7) {
  //         dateOutput = timeLaps + `${timeValues?.days}`;
  //       } else {
  //         timeLaps = DateDiff.inWeeks(d1, d2);
  //         if (timeLaps < 4) {
  //           dateOutput = timeLaps + `${timeValues?.weeks}`;
  //         } else {
  //           timeLaps = DateDiff.inMonths(d1, d2);
  //           if (timeLaps < 12) {
  //             dateOutput = timeLaps + `${timeValues?.months}`;
  //           } else {
  //             timeLaps = DateDiff.inYears(d1, d2);
  //             dateOutput = timeLaps + `${timeValues?.years}`;
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  // console.log('dateOutput');
  // // return dateOutput == '-1' + timeValues?.minutes
  // //   ? timeValues?.some + timeValues?.seconds
  // //   : dateOutput;
  // return dateOutput;
};
export default TimeFunction;
// alert(dateOutput);
